export default defineNuxtPlugin(async (nuxtApp) => {
  const authStore = useAuthStore();
  if (!authStore.isLoggedIn) {
    try {
      const profile = await $fetch("/api/auth/me", { credentials: "include" });
      authStore.setProfile(profile);
    } catch (err) {
      authStore.logout();
    }
  }
});
